<template>
  <component :is="componentName" v-model="localValue" overflowVisible>
    <payment-billing-info v-if="billingInfoStep" @back="billingInfoBack" @nextStep="goStep(SUMMARY)"></payment-billing-info>
    <payment-summary v-if="summaryStep" @back="goStep(BILLING_INFO)" :paymentDescription="paymentDescription" @nextStep="goStep(GATEWAY)" :price="price" :paymentType="paymentType" :appointmentDate="appointmentDate" :appointmentDisease="appointmentDisease" :appointmentReason="appointmentReason"></payment-summary>
    <component v-if="gatewayStep" :is="paymentComponent" @back="goStep(SUMMARY)" @closePaymentModal="$emit('closePaymentModal')" @loadAppointments="$emit('loadAppointments')" :paymentType="paymentType" :price="price" :appointmentId="appointmentId" :ePrescriptionAvailable="ePrescriptionAvailable" :copayment="copayment"
    :appointmentData="appointmentData" :servicesPackageId="servicesPackageId" :profIdForWrittenFlatRate="profIdForWrittenFlatRate" :paymentsTypes="paymentsTypes" @onFreeAppointmentOrBizumDirect="$emit('onFreeAppointmentOrBizumDirect', $event)"></component>
  </component>
</template>

<script>
import PaymentBillingInfo from './PaymentBillingInfo'
import PaymentSummary from './PaymentSummary'
import PaycometPayment from './PaycometPayment'
import OpenpayPayment from './OpenpayPayment'
import BaseModal from '@/components/base/BaseModal'
import { inMx } from '@/helpers/global.helpers'
import BaseCard from '@/components/base/ui/BaseCard'
import i18nMixin from '@/mixins/i18n.mixin'

const I18N_FILE = 'payments'
const BILLING_INFO = 'billingInfo'
const SUMMARY = 'summary'
const GATEWAY = 'gateway'
const PAYCOMET_COMPONENT = 'paycomet-payment'
const OPENPAY_COMPONENT = 'openpay-payment'
const BASE_MODAL_COMPONENT = 'base-modal'
const BASE_CARD_COMPONENT = 'base-card'

export default {
    props: {
        value: Boolean,
        paymentType: Number,
        price: Number,
        paymentDescription: String,
        appointmentId: Number,
        ePrescriptionAvailable: Boolean,
        copayment: Boolean,
        modal: Boolean,
        servicesPackageId: String,
        profIdForWrittenFlatRate: String,
        appointmentData: Object,
        paymentsTypes: Object
    },
    components: {
        BaseModal,
        PaymentBillingInfo,
        PaymentSummary,
        PaycometPayment,
        OpenpayPayment,
        BaseCard
    },
    mixins: [i18nMixin(I18N_FILE)],
    created () {
        if (this.appointmentData) {
            this.$store.dispatch('showSharedDialog', { content: this.$t(`warningChargeAppointmentWithBizum`) })
        }
    },
    data () {
        return {
            step: BILLING_INFO,
            BILLING_INFO,
            SUMMARY,
            GATEWAY
        }
    },
    computed: {
        componentName () {
            return this.modal ? BASE_MODAL_COMPONENT : BASE_CARD_COMPONENT
        },
        localValue: {
            get () {
                if (this.value) this.resetModal()
                return this.value
            },
            set (value) {
                this.$emit('input', value)
            }
        },
        billingInfoStep () {
            return this.step === BILLING_INFO
        },
        summaryStep () {
            return this.step === SUMMARY
        },
        gatewayStep () {
            return this.step === GATEWAY
        },
        paymentComponent () {
            return inMx ? OPENPAY_COMPONENT : PAYCOMET_COMPONENT
        },
        appointmentDate () {
            if (this.appointmentData) {
                return this.appointmentData.start
            }
            return null
        },
        appointmentDisease () {
            if (this.appointmentData) {
                return this.appointmentData.diseaseName
            }
            return null
        },
        appointmentReason () {
            if (this.appointmentData) {
                return this.appointmentData.reason
            }
            return null
        }
    },
    methods: {
        goStep (name) {
            this.step = name
        },
        resetModal () {
            this.goStep(BILLING_INFO)
        },
        billingInfoBack () {
            if (this.modal) {
                this.localValue = false
            } else {
                window.history.back()
            }
        }
    }
}
</script>

<style scoped lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/payment/PaymentView.vue